import { Navigate, useParams } from 'react-router-dom';
import { USER_ROUTES } from '../../../routes/userRoutes';

export function PatientEditPage() {
  const params = useParams<{ userId: string }>();
  const userId = Number(params.userId ?? 0);

  if (!Number.isFinite(userId) || userId <= 0) {
    return <Navigate to={USER_ROUTES.list} replace />;
  }

  return <Navigate to={USER_ROUTES.newMeasurement(userId)} replace />;
}
